import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { NoVehicleIdGuard } from 'src/app/gaurd/no-vehicle-id-guard';
import { RatingBodyType } from 'src/app/gaurd/rating.guard';
import { CarHistoryReportComponent } from './car-history-report/car-history-report.component';
import { EstimatesComponent } from './estimates/estimates.component';
import { FlagsComponent } from './flags/flags.component';
import { GalleryComponent } from './gallery/gallery.component';
import { InformationComponent } from './information/information.component';
import { OfflineDataComponent } from './offline-data/offline-data.component';
import { OptionsComponent } from './options/options.component';
import { VamComponent } from './vam.component';

const routes: Routes = [
  {
    path: '',
    component: VamComponent,
    children: [
      {
        path: '',
        pathMatch: 'prefix',
        redirectTo: 'information'
      },

      {
        path: 'information',
        component: InformationComponent,
        canActivate: [NoVehicleIdGuard]
      },
      {
        path: 'flags',
        component: FlagsComponent,
        canActivate: [NoVehicleIdGuard]
      },
      {
        //Importing the children module to load the components under Rating Module
        path: 'rating',
        loadChildren: () => import('./rating/rating.module').then((m) => m.RatingModule)
      },
      {
        path: 'estimates',
        component: EstimatesComponent,
        canActivate: [RatingBodyType]
      },
      {
        path: 'gallery',
        component: GalleryComponent,
        canActivate: [NoVehicleIdGuard]
      },
      {
        path: 'offline-data',
        component: OfflineDataComponent
      },
      {
        path: 'gallery-auction',
        component: GalleryComponent
      },
      {
        path: 'media',
        component: CarHistoryReportComponent
      },
      {
        path: 'options',
        component: OptionsComponent,
        canActivate: [NoVehicleIdGuard]
      },
      {
        //Importing the children module to load the components under Common Rating Module
        path: 'commonrating',
        loadChildren: () =>
          import('./commonrating/commonrating.module').then((m) => m.CommonRatingModule)
      }
    ]
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class VamRoutingModule {}
